export enum Language {
  PL = 'pl',
  EN = 'en',
  DE = 'de',
  ES = 'es',
  UA = 'ua',
}
